import { render, staticRenderFns } from "./workspace-question-view.vue?vue&type=template&id=7559b4ec&scoped=true&"
import script from "./workspace-question-view.vue?vue&type=script&lang=js&"
export * from "./workspace-question-view.vue?vue&type=script&lang=js&"
import style0 from "./workspace-question-view.vue?vue&type=style&index=0&id=7559b4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7559b4ec",
  null
  
)

export default component.exports